import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

import TextM from "@common/components/text/TextM"
import SatisfactionComponent from "@common/liveMode/SatisfactionComponent"
import LiveSatisfactionSection from "@common/liveMode/LiveSatisfactionSection"
import { ProxyCard } from "@common/liveMode/QualityClosureScreen"
import { theme } from "@common/theme/theme"
import { liveService } from "@data/services/liveService"

// Read-only "Les bases" section: one ProxyCard per axis (présence /
// connexion / environnement), OK or not. Tutor reassurance — the visible
// check on each axis matters even when nothing is wrong.
export const ProxiesSection = ({ tutorProxies = [] }) => (
    <View style={{ paddingVertical: 4 }}>
        {tutorProxies.map((proxy, i) => (
            <ProxyCard key={i} proxy={proxy} />
        ))}
    </View>
)

// Shown instead of the proxy axes when nobody attended. There is no session
// to grade in that case, so the card states what happened — including the time
// the tutor actually stayed — rather than scoring him against a session that
// never took place.
export const NoStudentCard = ({ tutorConnectionMinutes }) => (
    <View
        style={{
            backgroundColor: theme.colors.white,
            borderRadius: 12,
            padding: 14,
            marginBottom: 10,
            borderLeftWidth: 4,
            borderLeftColor: theme.colors.grey,
            shadowColor: "#000",
            shadowOpacity: 0.05,
            shadowRadius: 4,
            shadowOffset: { width: 0, height: 2 },
            elevation: 2,
        }}
    >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
            <FontAwesome5
                name="user-slash"
                size={16}
                color={theme.colors.grey}
                solid
            />
            <TextM
                fontWeight="SemiBold"
                fontSize={15}
                color={theme.colors.dark}
                style={{ marginLeft: 8, flex: 1 }}
                wrap
            >
                Personne n&apos;est venu à cette séance
            </TextM>
        </View>
        <TextM
            fontSize={13}
            color={theme.colors.grey}
            style={{ marginTop: 6 }}
            wrap
        >
            {tutorConnectionMinutes > 0
                ? `Tu es resté ${tutorConnectionMinutes} min. Il n'y a pas de bilan qualité à faire.`
                : "Il n'y a pas de bilan qualité à faire."}
        </TextM>
    </View>
)

// Tutor's own satisfaction on platform behavior (rating + tags + vocal/text),
// saved via sendLiveQuality / LiveSatisfactionSection. Lives at the bottom of
// the close-out flow, after the student cards.
export const PlatformSatisfactionCard = ({
    occurrenceId,
    qualityScore,
    setQualityScore,
    liveSatisfactionTags,
    liveSatisfactionRecord,
    liveSatisfactionInitialComment,
}) => (
    <View
        style={{
            backgroundColor: theme.colors.white,
            borderRadius: 12,
            padding: 14,
            marginTop: 2,
            shadowColor: "#000",
            shadowOpacity: 0.05,
            shadowRadius: 4,
            shadowOffset: { width: 0, height: 2 },
            elevation: 2,
        }}
    >
        <View style={{ alignItems: "center", paddingVertical: 4 }}>
            <TextM
                fontSize={14}
                fontWeight="Bold"
                color={theme.colors.primary}
                center
                wrap
            >
                Qu&apos;as-tu pensé de ton expérience pendant ce live ?
            </TextM>
            <TextM
                fontSize={12}
                color={theme.colors.grey}
                center
                wrap
                style={{ marginTop: 4 }}
            >
                Indépendamment des élèves — visio, son, outils.
            </TextM>
        </View>
        <SatisfactionComponent
            rating={qualityScore}
            setRating={setQualityScore}
            withApiRequest
            requestApiService={liveService.sendLiveQuality}
            requestRouteParams={{ id: occurrenceId }}
            requestData={{ quality_score: qualityScore }}
        />
        {!!qualityScore && (
            <LiveSatisfactionSection
                occurrenceId={occurrenceId}
                qualityScore={qualityScore}
                initialTags={liveSatisfactionTags ?? []}
                initialComment={liveSatisfactionInitialComment ?? ""}
                initialRecordingURI={liveSatisfactionRecord ?? null}
            />
        )}
    </View>
)

// Back-compat default export — old imports get the proxies section.
const SessionCard = ProxiesSection
export default SessionCard
